import React from 'react';
import Text from '../text';

const MemoSubTitle = ({ title }) => {
  return <Text text={title} classes="sp-subtitle" />;
};

export default MemoSubTitle;
